import inView from 'in-view';
import $ from 'jquery';
import timing from 'DesignSystem/motion/timing';

const siblingsSwitcher = (_options?: {
  cssClass?: string,
  cssClassDefault?: string,
  container?: string,
  titleLabelTag?: string,
  legendTag?: string,
  selectorTag?: string,
  selectorList?: string,
  selectorItem?: string,
  selectorActive?: string,
  amountInformations?: object,
  defaultSelect?: boolean,
  submit?: boolean,
}) => {
  const opt = {
    cssClass: '.SiblingsSwitcher',
    cssClassDefault: 'SiblingsSwitcher',
    container: '',
    titleLabelTag: 'h1',
    legendTag: '',
    selectorTag: '.SiblingsSwitcher-tag',
    selectorList: '.SiblingsSwitcher-list',
    selectorItem: '.SiblingsSwitcher-item > a',
    selectorActive: '.form-type-radio input:checked + label',
    amountInformations: {},
    defaultSelect: false,
    submit: false,
    ..._options
  };
  const target: string = opt.cssClass;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClassDefault}`]) {
      continue; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${opt.cssClassDefault}`] = true;

    // Create title
    const itemActive = elt.querySelector(opt.selectorActive);
    if(itemActive) {

    let titleHTML: HTMLElement = elt.querySelector(`.${opt.cssClassDefault}-title`);
    if(titleHTML === null) {
      titleHTML = document.createElement('div');
      titleHTML.classList.add(`${opt.cssClassDefault}-title`);
    }
    const select: HTMLSelectElement = document.createElement('select');
    if(opt.container === '') {
      elt.appendChild(titleHTML);
      elt.appendChild(select);
    } else {

      const container = document.querySelector(`${opt.container}`);
      const titleViewHeader: HTMLElement = container.querySelector(`.${opt.cssClassDefault}-title`);
      if(titleViewHeader !== null) {
        titleHTML = titleViewHeader;
      }
      const clonedElt: HTMLElement = document.createElement('div');
      clonedElt.classList.add(`${opt.cssClassDefault}`);
      container.insertBefore(clonedElt, container.firstChild);
      clonedElt.appendChild(titleHTML);
      clonedElt.appendChild(select);
      const legend = elt.querySelector('legend');
      legend.classList.add(`${opt.cssClassDefault}-top`);
      clonedElt.insertBefore(legend, clonedElt.firstChild);
    }
    let titleLabel: HTMLElement = titleHTML.querySelector(opt.titleLabelTag);
    if(titleLabel === null) {
      titleLabel = document.createElement(opt.titleLabelTag);
      titleHTML.appendChild(titleLabel);
    }
    titleLabel.classList.add(`${opt.cssClassDefault}-label`);
    if (itemActive) {
      titleLabel.innerText= String(itemActive.textContent);
    }
    const amountHTML: HTMLElement = document.createElement('span');
    amountHTML.classList.add(`${opt.cssClassDefault}-amount`);
    titleHTML.appendChild(amountHTML);

    if(opt.legendTag !== '') {
      const legend = elt.querySelector('legend');
      const tagName = document.createElement(opt.legendTag);
      tagName.innerText = legend.textContent;
      tagName.classList.add('fieldset-legend');
      legend.innerHTML = '';
      legend.appendChild(tagName);
    }

    const optionsName = [];
    const items = elt.querySelectorAll(`${opt.selectorItem}`);
    const numItem = items.length;

    let key = 0;
    for (const itemHtml of items) {

      if (!itemHtml.hasAttribute('data-termid')) {
        itemHtml.setAttribute('data-termid', $(itemHtml).prev('input').length ?
          $(itemHtml).prev('input').val() :
          key
        );
      }

      key++;
      const termId = itemHtml.getAttribute('data-termid');
      const itemInformations = (opt.amountInformations as any)[termId];
      const itemAmount = typeof itemInformations !== 'undefined' ? itemInformations.amount : '';
      const itemName = String(itemHtml.innerHTML);

      if (itemHtml !== null && itemHtml !== '') {
        const option: HTMLElement = document.createElement('option');
        option.innerHTML = itemName;
        if (opt.defaultSelect === true && termId !== 'All') {
          optionsName.push(itemName);
        }
        itemHtml.label = itemName;
        itemHtml.amount = '';
        option.setAttribute('value', termId);
        select.appendChild(option);

        // Add the amount to the corresponding item
        if (itemAmount && itemAmount !== '') {
          itemHtml.amount = ` (${itemAmount})`;
          const itemAmountHTML: HTMLElement = document.createElement('span');
          itemAmountHTML.classList.add(`${opt.cssClassDefault}-amount`);
          itemAmountHTML.innerHTML = ` (${itemAmount})`;
          itemHtml.appendChild(itemAmountHTML);
          option.innerHTML += ` (${itemAmount})`;
        }
      }
    }
    // generate label title with all option
    const defaultClass = 'isDefault';

    if (optionsName.length) {
      const optionAll: HTMLElement = select.querySelector('[value="All"]');
      const itemHTMLAll = elt.querySelector(`${opt.selectorItem}[data-termid="All"]`);
      itemHTMLAll.label = optionsName.join(', ');
      const limitStrLength = 50;
      optionAll.innerHTML = itemHTMLAll.label.length > limitStrLength ? `${itemHTMLAll.label.slice(0, limitStrLength)}...` : itemHTMLAll.label;

      // if first item active is Default Selected (all)
      if (itemActive && itemActive.getAttribute('data-termid') === 'All' && !titleHTML.classList.contains(defaultClass)) {
        addDefaultClass();
        titleLabel.innerText = optionsName.join(', ');
      } else {
        removeDefaultClass();
      }
    }

    if (itemActive && itemActive.querySelector(`.${opt.cssClassDefault}-amount`) !== null) {
      amountHTML.innerText = itemActive.querySelector(`.${opt.cssClassDefault}-amount`).innerHTML;

      // if component is in ListPreview we update the number of results
      const $listPreview = $(elt).closest('.ListPreview'); // closest in jquery for more compatibility
      if($listPreview.length) {
        const $button = $listPreview.find(`.ListCross-action .ButtonPrimary`);
        const labelSingle = typeof Drupal !== 'undefined' ? Drupal.t('Voir l‘emploi') : 'Voir l‘emploi';
        const labelPlural = typeof Drupal !== 'undefined' ? Drupal.t('Voir les %number% emplois') : 'Voir les %number% emplois';
        // extract numbers from string
        const countStr = amountHTML.innerText.match(/\d+/g).map(Number).join('');
        const count = +countStr;
        const label = count > 1 ? labelPlural : labelSingle;
        $button.text(label.split('%number%').join(countStr));
      }
    }
    if (itemActive) {
      const optionActive = select.querySelector(`option[value="${itemActive.dataset.termid}"]`);
      optionActive.setAttribute('selected', 'selected');
    }
    const list = elt.querySelector(`${opt.selectorList}`);
    if (list) {
      list.style.display = 'none';
    }

    select.addEventListener('change', (_event) => {
      const selectedItem = elt.querySelector(`${opt.selectorItem}[data-termid="${select.value}"]`);
      titleLabel.innerText = selectedItem.label.replace('&amp;', '&');
      amountHTML.innerText = selectedItem.amount;
      // if menu link
      if (selectedItem.getAttribute('href') !== null) {
        document.location.href = selectedItem.getAttribute('href');
      }
      // if form filter
      if (selectedItem.getAttribute('for') !== null) {
        const input = document.getElementById(selectedItem.getAttribute('for'));
        $(input).prop('checked', true);
        $(input).attr('checked', 'checked');
        $(input).trigger('change');
        if(opt.submit === true) {
          $(input).closest('form').trigger('submit');
        }
      }
      // if selected all
      if (selectedItem.getAttribute('data-termid') === 'All' && !titleHTML.classList.contains(defaultClass)) {
        addDefaultClass();
      } else {
        removeDefaultClass();
      }
    });

    if (numItem === 1) {
      select.style.display = 'none';
      elt.classList.add('hasSingleItem');
    }

    function addDefaultClass() {
      titleHTML.classList.remove(defaultClass);
      titleHTML.classList.add(defaultClass);
    }

    function removeDefaultClass() {
      titleHTML.classList.remove(defaultClass);
    }

    // animate tag display
    const tag = elt.querySelector(opt.selectorTag);
    if (tag !== null) {
      inView.offset(0);
      tag.classList.add('isAnimated');
      inView(opt.cssClass)
        .on('enter', () => {
          setTimeout(() => {
            tag.classList.add('isInViewport');
          }, timing.params.fast);
        });
    }

    } // enf if(itemActive) (from ln53)
  } // end LOOP @ln40 -> for (const elt of targets) {
};

export default siblingsSwitcher;
